// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-navigation__menu-btn {
    width: 3rem;
    height: 3rem;
    background: transparent;
    border: none;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-right: 2rem;
    cursor: pointer;
  }

  .main-navigation__menu-btn span {
    display: block;
    width: 2.5rem;
    height: 2.5px;
    background: #888;
  }

  .main-navigation__title {
    color: #ccc;
  }

  .main-navigation__title a {
    text-decoration: none;
    color: #ccc;
  }

  .main-navigation__title a:hover {
    color: #00d97e;
  }

  /* New styles for title switching */
  .main-navigation__title .full-title {
    display: none; /* Hidden by default (overridden on larger screens) */
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  .main-navigation__title .short-title {
    display: inline; /* Shown by default on small screens */
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  .main-navigation__header-nav {
    display: none;
  }

  .main-navigation__drawer-nav {
    height: 100%;
  }

  @media (min-width: 768px) {
    .main-navigation__menu-btn {
      display: none;
    }

    .main-navigation__header-nav {
      display: block;
    }

     /* New styles for title switching */
    .main-navigation__title .full-title {
      display: inline; /* Visible on larger screens */
      color: #fff;
    }

    .main-navigation__title .short-title {
      display: none; /* Shown by default on small screens */
    }
  }`, "",{"version":3,"sources":["webpack://./src/shared/components/Navigation/MainNavigation.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA,mCAAmC;EACnC;IACE,aAAa,EAAE,qDAAqD;IACpE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,eAAe,EAAE,sCAAsC;IACvD,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;KAEC,mCAAmC;IACpC;MACE,eAAe,EAAE,8BAA8B;MAC/C,WAAW;IACb;;IAEA;MACE,aAAa,EAAE,sCAAsC;IACvD;EACF","sourcesContent":[".main-navigation__menu-btn {\n    width: 3rem;\n    height: 3rem;\n    background: transparent;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    margin-right: 2rem;\n    cursor: pointer;\n  }\n\n  .main-navigation__menu-btn span {\n    display: block;\n    width: 2.5rem;\n    height: 2.5px;\n    background: #888;\n  }\n\n  .main-navigation__title {\n    color: #ccc;\n  }\n\n  .main-navigation__title a {\n    text-decoration: none;\n    color: #ccc;\n  }\n\n  .main-navigation__title a:hover {\n    color: #00d97e;\n  }\n\n  /* New styles for title switching */\n  .main-navigation__title .full-title {\n    display: none; /* Hidden by default (overridden on larger screens) */\n    color: #fff;\n    font-size: 24px;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n  }\n\n  .main-navigation__title .short-title {\n    display: inline; /* Shown by default on small screens */\n    font-size: 24px;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n  }\n\n  .main-navigation__header-nav {\n    display: none;\n  }\n\n  .main-navigation__drawer-nav {\n    height: 100%;\n  }\n\n  @media (min-width: 768px) {\n    .main-navigation__menu-btn {\n      display: none;\n    }\n\n    .main-navigation__header-nav {\n      display: block;\n    }\n\n     /* New styles for title switching */\n    .main-navigation__title .full-title {\n      display: inline; /* Visible on larger screens */\n      color: #fff;\n    }\n\n    .main-navigation__title .short-title {\n      display: none; /* Shown by default on small screens */\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
